__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "admin-panel";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.6.6", () => (Promise.all([__webpack_require__.e(357), __webpack_require__.e(380), __webpack_require__.e(785)]).then(() => (() => (__webpack_require__(6357))))));
			register("graphql", "16.8.1", () => (__webpack_require__.e(553).then(() => (() => (__webpack_require__(2553))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(250).then(() => (() => (__webpack_require__(5250))))));
			register("mobx-react-lite", "3.4.0", () => (Promise.all([__webpack_require__.e(909), __webpack_require__.e(380), __webpack_require__.e(845)]).then(() => (() => (__webpack_require__(909))))));
			register("mobx", "6.6.0", () => (__webpack_require__.e(794).then(() => (() => (__webpack_require__(3794))))));
			register("react-dom", "18.1.0", () => (Promise.all([__webpack_require__.e(144), __webpack_require__.e(380)]).then(() => (() => (__webpack_require__(3144))))));
			register("react-router-dom", "6.3.0", () => (Promise.all([__webpack_require__.e(900), __webpack_require__.e(380)]).then(() => (() => (__webpack_require__(4900))))));
			register("react-toastify", "9.0.3", () => (Promise.all([__webpack_require__.e(380), __webpack_require__.e(691)]).then(() => (() => (__webpack_require__(6691))))));
			register("react", "18.1.0", () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(4041))))));
			initExternal(7052);
			initExternal(1130);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};